import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import enAuth from "./locales/en/auth.json";
import deAuth from "./locales/de/auth.json";
import frAuth from "./locales/fr/auth.json";

// Import admin translations
import enAdmin from "./locales/en/admin.json";
import deAdmin from "./locales/de/admin.json";
import frAdmin from "./locales/fr/admin.json";

// Import header translations
import enHeader from "./locales/en/header.json";
import deHeader from "./locales/de/header.json";
import frHeader from "./locales/fr/header.json";

// Import settings translations
import enSettings from "./locales/en/settings.json";
import deSettings from "./locales/de/settings.json";
import frSettings from "./locales/fr/settings.json";

// Import profile translations
import enProfile from "./locales/en/profile.json";
import deProfile from "./locales/de/profile.json";
import frProfile from "./locales/fr/profile.json";

// Import cookie consent translations
import enCookieConsent from "./locales/en/cookieConsent.json";
import deCookieConsent from "./locales/de/cookieConsent.json";
import frCookieConsent from "./locales/fr/cookieConsent.json";

const resources = {
  en: {
    auth: enAuth,
    admin: enAdmin,
    header: enHeader,
    settings: enSettings,
    profile: enProfile,
    cookieConsent: enCookieConsent,
  },
  de: {
    auth: deAuth,
    admin: deAdmin,
    header: deHeader,
    settings: deSettings,
    profile: deProfile,
    cookieConsent: deCookieConsent,
  },
  fr: {
    auth: frAuth,
    admin: frAdmin,
    header: frHeader,
    settings: frSettings,
    profile: frProfile,
    cookieConsent: frCookieConsent,
  },
};

// Get saved language
const savedLang = localStorage.getItem("appLanguage");
const browserLang = navigator.language.split("-")[0];
const defaultLang =
  savedLang ||
  (resources[browserLang as keyof typeof resources] ? browserLang : "en");

i18n.use(initReactI18next).init({
  resources,
  lng: defaultLang,
  fallbackLng: "en",
  defaultNS: "auth",
  ns: [
    "auth",
    "admin",
    "header",
    "settings",
    "profile",
    "cookieConsent",
  ],

  interpolation: {
    escapeValue: false,
  },
});

// Save language when changed
i18n.on("languageChanged", (lng) => {
  localStorage.setItem("appLanguage", lng);
  document.documentElement.lang = lng;
});

export default i18n;
